@if (visible()) {
  <div
    #overlayRef
    class="ly-overlay"
    [class]="`ly-overlay--${color()}`"
    [class.ly-overlay--behind-modals]="isBehindModals()"
    [class.ly-overlay--solid]="solid()"
    [class.ly-overlay--top-layer]="isTopLayer()"
    [attr.popover]="isTopLayer() ? 'manual' : null"
    [@overlay]="{ value: visible(), params: { enterDuration: skipEnterAnimation() ? '0ms' : '.4s' } }"
  >
    @if (showCloseButton()) {
      <aw-dismiss-button class="ly-overlay__close"
        [isClose]="true"
        [size]="Size.m"
        (onClick)="hide()"
      />
    }
    <!-- Content Outlet -->
    <ng-content />
  </div>
}
